import './BasicDetails.scss';
import { useEffect, useState } from 'react';
import CustomUpload from '../../Components/custom-upload/CustomUpload';
import { useToggle } from '../../../../hooks';
import ViewSampleModal from './view-sample-modal/ViewSampleModal';
import {  useGetAllSubDivisionsQuery } from '../../../../services/countries';
import { basicDetailsUsaFormSchema, BASIC_DETAILS_FORM_KEYS, customizeRadioButtonData } from './BasicDetailsConfig'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../../config/routes';
import { useDispatch, useSelector } from 'react-redux'
import { basicDetailsDataRedux, selectAllData, setBasicDetails, resetAllRecruitmentData, selectIsBasicDetailsFilled, setReferenceChecks, setDeclaration, setGrantPermission } from '../../RecruitmentDataSlice'
import { selectUser } from '../../../login-page/LoginAuthSlice';
import { useForm } from "react-hook-form"
import { Checkbox } from 'primereact/checkbox';
import BasicDetailsController from './BasicDetailsController';
import { joiResolver } from '@hookform/resolvers/joi';
import CustomizeRadioButton from '../../../../components/customize-radio-button/CustomizeRadioButton'
import Button from '../../../../components/prime-react-overrides/button/Button'
import UsaHiringDocuments from '../usa-hiring-documents/UsaHiringDocuments'
import { ReactComponent as Logo } from "../../../../assets/JCRRunwayLogo.svg"
import { ReactComponent as SentIcon } from "./../../../../assets/recruitment/Onboarding/MDI - send.svg"
import { useUpdateSingleCandidateMutation } from '../../../../services/attendance-portal/recruitment/onboarding';
import { countriesData } from '../../../../config/countries';
import { countryOptionTemplate, selectedCountryTemplate } from '../../../../utilities/country';


function BasicDetails() {
  const newUser = useSelector(selectUser)
  console.log("🚀 ~ file: BasicDetails.jsx:29 ~ BasicDetails ~ newUser:", newUser)
  const allStateData = useSelector(selectAllData)

  const { data: subDivision } = useGetAllSubDivisionsQuery()
  const { email, firstName, lastName, state } = newUser
  const [submitDetails, { isLoading: isloading }] = useUpdateSingleCandidateMutation()
  const [isShowImageSampleModal, setIsShowImageSampleModal] = useToggle(false)
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const basicDetailsData = useSelector(basicDetailsDataRedux)

  const isBasicDetailsFilled = useSelector(selectIsBasicDetailsFilled)
  const { image, gender, mailingAddress, city, zipCode, emergencyNumber, subDivisionCode, personalPhoneNumber, countryCode, subDivisionName, subDivisionCategory } = basicDetailsData
  const [selectedSubDivisionCode, setSelectedSubDivisionCode] = useState(subDivisionCode);

  const { isUsaHiringDocsCollected, declaration, grantPermission } = allStateData

  useEffect(() => {
    if (isBasicDetailsFilled || allStateData.isEmailVerified === false) {
      const previousPath = `${ROUTES.RECRUITMENT}/${ROUTES.ONBOARDING}`
      navigate(previousPath)
    }


  }, [])


  const { control, formState: { errors }, handleSubmit, getValues, setValue } = useForm({
    resolver: joiResolver(basicDetailsUsaFormSchema),
    defaultValues: {
      [BASIC_DETAILS_FORM_KEYS.FIRST_NAME]: firstName,
      [BASIC_DETAILS_FORM_KEYS.LAST_NAME]: lastName,
      [BASIC_DETAILS_FORM_KEYS.MAILING_ADDRESS]: mailingAddress,
      [BASIC_DETAILS_FORM_KEYS.PERSONAL_EMAIL_ADDRESS]: email,
      [BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_NUMBER]: personalPhoneNumber,
      [BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_CODE]: countryCode,
      [BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE]: '',
      [BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME]: '',
      [BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY]: '',
      [BASIC_DETAILS_FORM_KEYS.ZIP_CODE]: zipCode,
      // [BASIC_DETAILS_FORM_KEYS.STATE_NAME]: state,
      [BASIC_DETAILS_FORM_KEYS.CITY_NAME]: city,
    }
  })

  function handleCheck(isChecked) {
    dispatch(setDeclaration({ declaration: isChecked }))
  }
  function handleGrantPermission(isChecked) {
    dispatch(setGrantPermission({ grantPermission: isChecked }))
  }


  const handleFormSubmit = async (e) => {
    dispatch(setBasicDetails({ ...basicDetailsData, email, firstName: e[BASIC_DETAILS_FORM_KEYS.FIRST_NAME], lastName: e[BASIC_DETAILS_FORM_KEYS.LAST_NAME], zipCode: e[BASIC_DETAILS_FORM_KEYS.ZIP_CODE], state: e[BASIC_DETAILS_FORM_KEYS.STATE_NAME], city: e[BASIC_DETAILS_FORM_KEYS.CITY_NAME], personalPhoneNumber: e[BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_NUMBER], mailingAddress: e[BASIC_DETAILS_FORM_KEYS.MAILING_ADDRESS], countryCode: e[BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_CODE], subDivisionCode: e[BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE], subDivisionName: e[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME], subDivisionCategory: e[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY] }))

    const payload = {
      ...basicDetailsData,
      personalEmail: email,
      firstName: e[BASIC_DETAILS_FORM_KEYS.FIRST_NAME],
      lastName: e[BASIC_DETAILS_FORM_KEYS.LAST_NAME],
      zipCode: e[BASIC_DETAILS_FORM_KEYS.ZIP_CODE],
      city: e[BASIC_DETAILS_FORM_KEYS.CITY_NAME],
      countryCode: e[BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE],
      subDivisionCode: e[BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE],
      subDivisionName: e[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME],
      subDivisionCategory: e[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY],
      personalPhoneNumber: e[BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_NUMBER],
      mailingAddress: e[BASIC_DETAILS_FORM_KEYS.MAILING_ADDRESS],
      countryCode: e[BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_CODE],
    }

    const response = await submitDetails(payload)

    const nextPath = `${ROUTES.RECRUITMENT}/${ROUTES.ONBOARDING}/${ROUTES.ONBOARDING_SUCCESS}`
    navigate(nextPath)

  }
  const updateImageLink = (base64, type) => {
    dispatch(setBasicDetails({ ...basicDetailsData, image: { base64, type } }))
  }
  const handleSubDivisionCodeChange = (event) => {
    const code = event.target.value;
    setSelectedSubDivisionCode(code);

    const selectedSubDivision = subDivision?.find((subDiv) => subDiv?.subDivisionCode === code);

    if (selectedSubDivision) {
      setValue(BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME, selectedSubDivision?.subDivision)
      setValue(BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY, selectedSubDivision?.subDivisionCategory)
      // setSelectedSubDivisionName(selectedSubDivision?.subDivision);
      // setSelectedSubDivisionCategory(selectedSubDivision?.subDivisionCategory);
    }
    //  else {
    //   setSelectedSubDivisionName('');
    //   setSelectedSubDivisionCategory('');
    // }
  };



  return (

    <>
      <ViewSampleModal onShow={isShowImageSampleModal} onHide={setIsShowImageSampleModal} />
      <div className='BasicDetails flex flex-columns mx-8'>
        <div className="LogoContainer left-50 fixed w-full my-8">
          <div className='flex flex-column justify-content-center align-items-center'>
            <Logo className='w-12rem ' />
            <div className="LogoSectionPara  font-light text-lg uppercase flex justify-content-center align-items-center">
              <p>
                LET'S GET YOU ONBOARD!
              </p>
              <SentIcon className="SentIcon" />
            </div>
          </div>
        </div>
        <div className="BasicDetailsUsaForm ">
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className='FormContentContainer p-6'>
              <h2 className='font-bold text-2xl m-0'>Basic Details</h2>
              <div className='flex  my-4 ' >
                <div>
                  <CustomUpload imageLink={image.base64} imageType={image.type} updateImageLink={updateImageLink} showEditTextHide={true} />
                </div>
                <div className=' m-0 ml-4 flex flex-column justify-content-end' >
                  <h6 className='m-0 cursor-pointer underline font-semibold text-xs' style={{ color: "#670BF2" }} onClick={setIsShowImageSampleModal}>  View Sample
                  </h6>
                </div>
              </div>
              <div className="field">
                <div className="grid justify-content-between ">
                  <div className="col-6 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.FIRST_NAME} fieldName="First Name *" />
                  </div>
                  <div className="col-6 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.LAST_NAME} fieldName="Last Name *" />
                  </div>
                  <div className="col-12 my-2">
                    <div className="flex">
                      <h6 className='my-2 mr-4 Labels'>Gender *</h6>
                      {Object.getOwnPropertyNames(customizeRadioButtonData).map((key, _id) =>
                        <CustomizeRadioButton key={_id} className="GreyTheme mr-3 text-sm" name={gender} id={customizeRadioButtonData[key].id} checked={gender === key} onChange={() => { dispatch(setBasicDetails({ ...basicDetailsData, gender: key })) }} label={key} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.MAILING_ADDRESS} fieldName="Mailing Address *" isTextArea={true} />
                  </div>
                  <div className="col-6 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.ZIP_CODE} fieldName="ZIP Code *" />
                  </div>
                  {/* <div className="col-4 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.STATE_NAME} disabled={true} fieldName="Sub Division *" />
                  </div> */}
                  <div className="col-6 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.CITY_NAME} fieldName="City *" />
                  </div>
                  <div className="col-2 my-2">
                    <BasicDetailsController
                      errors={errors}
                      isDropdown={true}
                      options={subDivision}
                      className="PhoneDropdown"
                      control={control}
                      fieldKey={BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE}

                      fieldName="Country Code *"
                      filter
                      handleChange={handleSubDivisionCodeChange}
                      optionLabel="subDivisionCode"
                      optionValue="subDivisionCode"
                      filterBy='subDivisionCode'
                    />
                  </div>
                  <div className="col-5 my-2">
                    <BasicDetailsController
                      errors={errors}
                      control={control}
                      fieldKey={BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME}
                      fieldName="Sub Division Name *"
                      disabled={true}
                      value={getValues()[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME]}
                      className='PersonalEmail'
                    />
                  </div>
                  <div className="col-5 my-2">
                    <BasicDetailsController
                      errors={errors}
                      control={control}
                      fieldKey={BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY}
                      value={getValues()[BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY]}
                      disabled={true}
                      fieldName="Sub Division Category *"
                      className='PersonalEmail'
                    />
                  </div>
                  <div className="col-6 my-2">
                    <div className='flex flex-column'>
                      <BasicDetailsController className='PersonalEmail lowercase' errors={errors} fieldKey={BASIC_DETAILS_FORM_KEYS.PERSONAL_EMAIL_ADDRESS} control={control} disabled={true} value={email} fieldName="Personal Email Address *" />
                    </div>
                  </div>
                  <div className="col-2 my-2">
                    <BasicDetailsController
                      fieldKey={BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_CODE}
                      isDropdown={true}
                      errors={errors}
                      control={control}
                      options={countriesData}
                      className="PhoneDropdown"
                      fieldName="Phone Code *"
                      valueTemplate={selectedCountryTemplate}
                      filter
                      optionLabel="name"
                      optionValue="dial_code" filterBy='name' itemTemplate={countryOptionTemplate}
                    />
                  </div>
                  <div className="col-4 my-2">
                    <BasicDetailsController errors={errors} control={control} fieldKey={BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_NUMBER} fieldName="Personal Phone Number *" />
                  </div>
                </div>
              </div>
              <hr className="Hr my-5" />

              <UsaHiringDocuments />

              <div className="AgreeToTerm flex align-items-start py-3">
                <Checkbox inputId="cb1" className='mx-2' checked={declaration} onChange={(e) => handleCheck(e.checked)} />
                <label htmlFor="cb1" className="p-checkbox-label text-left text-sm ml-2">
                  I hereby confirm that the above information is true to the best of my knowledge and understanding. In case Jasper Colin discovers any conflicting information, they have full rights to cancel my candidature.
                </label>
              </div>
              <div className="AgreeToTerm flex align-items-start py-3">
                <Checkbox inputId="cb2" className='mx-2' checked={grantPermission} onChange={(e) => handleGrantPermission(e.checked)} />
                <label htmlFor="cb2" className="p-checkbox-label text-left text-sm ml-2">
                  I authorize Jasper Colin to collect and retain the specified personal information for the duration of my employment with Jasper Colin.
                </label>
              </div>
            </div>
            <div className="flex justify-content-center mt-6 mb-5">

              <Button label='Submit' type="submit" className="SubmitButtonOverride uppercase"
                disabled={(!image.base64 || gender === '' || !isUsaHiringDocsCollected || !declaration || !grantPermission) && true}
                loading={isloading} />
            </div>
          </form>
        </div>
      </div >

    </>
  )

}


export default BasicDetails